import React, { useEffect, useRef } from 'react';
import './ChallengeCarousel.scss';
import Slider from 'react-slick';
import ChallengeCarouselLoader from '../challengeCarouselLoader/ChallengeCarouselLoader';
import { calculateDaysLeft, getChallengeTodayDate, getIsoFormattedDate, initializeLiff, thaiDate } from '../../../utill.func';
import ChallengeUsers from '../challengeUsers/ChallengeUsers.jsx';
import ChallengeUsersLoader from '../challengeUsers/ChallengeUsersLoader';
import { ALIGN_CLASS, CAROUSEL_CARD_DATES, CHALLENGE, CHALLENGE_LIST, ChallengeTeamdashboardStatus, rectBadgeClassname } from '../../../common/challengeConstants';
import ChallengeTag from '../challengeTag/ChallengeTag';
import CustomSweetAlert from '../../../common/customSweetAlert/CustomSweetAlert.jsx';
import BeginChallengeTag from '../beginChallengeTag/BeginChallengeTag.jsx';

const ChallengeCarousel = ({
  title,
  carouselList = [],
  isLoading,
  onCardClick,
  challengeProfileList = [],
  isProfileLoading = false,
  showTag = false,
  beginChallengeProfileList,
  onBeginChallengeClick
}) => {
  const settings = {
    dots: false,
    nav: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    initialSlide: 0
  };

  const getProfileStatus = (cardObj) => {
    const { eventId } = cardObj || {};
    if (eventId) {
      const eventProfileObj = challengeProfileList?.find(
        (profileObj) => eventId === profileObj?.teamInfo?.eventId
      ) ?? null;
      const eventTeam = eventProfileObj && eventProfileObj.teamInfo;
      const eventUsers = eventProfileObj && eventProfileObj.usersInfo;
      const isRegistered = eventUsers?.length > 0;
      const { approveDate, teamSize, challengeDate } = eventTeam || {};
      const tagStatus = eventProfileObj && eventProfileObj.tagStatus;
      const isChallengeStarted = !!approveDate;
      return {
        eventProfileObj,
        eventTeam,
        isRegistered,
        tagStatus,
        teamSize,
        isChallengeStarted,
        challengeDate
      }
    }
  };

  const getBeginProfileStatus = (cardObj) => {
    const { eventId } = cardObj || {};
    if (eventId) {
      const eventProfileObj = beginChallengeProfileList?.find(
        (profileObj) => eventId === profileObj?.teamInfo?.eventId
      ) ?? null;
      const eventTeam = eventProfileObj && eventProfileObj.teamInfo;
      const eventUsers = eventProfileObj && eventProfileObj.usersInfo;
      const isRegistered = eventUsers?.length > 0;
      const { approveDate, teamSize, challengeDate } = eventTeam || {};
      const tagStatus = eventProfileObj && eventProfileObj.tagStatus;
      const isChallengeStarted = !!approveDate;
      return {
        eventProfileObj,
        eventTeam,
        isRegistered,
        tagStatus,
        teamSize,
        isChallengeStarted,
        challengeDate,
      }
    }
  }

  const handleCardClick = (cardObj, isRegistered, inActiveClass, challengeType) => {
    if (!inActiveClass) {
      onCardClick(cardObj, isRegistered, challengeType);
    }
  }

  const handleInviteClick = async (e, link) => {
    e.stopPropagation();
    try {
      const liff = await initializeLiff();
      if (liff) {
        await liff.shareTargetPicker(
          [
            {
              type: "text",
              text: link,
            },

          ],
          {
            isMultiple: true,
          }
        )
      }
    } catch (error) {
      CustomSweetAlert({
        title: "",
        text: "Error handling LIFF action",
        confirmButtonText: "ตกลง",
      });
    }
  }

  const isRegDateExpired = (regEndDate) => getChallengeTodayDate() > getIsoFormattedDate(regEndDate);

const getDetailsContent = (cardObj, profileObj, tagStatus, canRegister) => {
    const {
      challengeStatus: challengeType,
      startDate: regStartDate,
      completeDate: rewardEndDate,
      endDate: regEndDate
    } = cardObj || {};
    const {
      complete60Date,
      weightoutDate: { startDate: weightStartDate, endDate: weightEndDate } = {},
      completeTeamIn,
    } = profileObj?.teamInfo || {};
    const todayDate = getChallengeTodayDate();
    const daysLeftToReg = calculateDaysLeft(regEndDate);
    const daysTeamDeadLine = calculateDaysLeft(completeTeamIn);
    const regEndOnlyDate = getIsoFormattedDate(regEndDate);
    const dateCompleteFormat = 'dd MMM yy';
    const dateMonthFormat = 'dd MMM';

    if (challengeType === CHALLENGE_LIST.TYPES.upcoming){
      if(todayDate <= regEndDate){
        return `${CAROUSEL_CARD_DATES.upcoming.beforeReg} ${thaiDate(regStartDate, dateCompleteFormat)} - ${thaiDate(regEndDate, dateCompleteFormat)}`
      }
    }

    if (challengeType === CHALLENGE_LIST.TYPES.ongoing && canRegister) {
      return `${CAROUSEL_CARD_DATES.upcoming.duringReg} ${thaiDate(regEndDate, dateMonthFormat)}${
          todayDate === regEndOnlyDate
            ? ''
            : ` (${CAROUSEL_CARD_DATES.daysLeft(daysLeftToReg)})`
        }`
    }

    if (challengeType === CHALLENGE_LIST.TYPES.ongoing) {
      switch (tagStatus) {
        case ChallengeTeamdashboardStatus.not_yet_started:
          if (todayDate <= regEndDate) {
            return `${CAROUSEL_CARD_DATES.ongoing.notStarted} ${thaiDate(completeTeamIn, dateMonthFormat)} (${CAROUSEL_CARD_DATES.daysLeft(daysTeamDeadLine + 1)})`;
          }
          break;
        case ChallengeTeamdashboardStatus.ready_to_start:
          if (todayDate < regEndDate) {
            return `${CAROUSEL_CARD_DATES.ongoing.readyToStart}`;
          }
          break;
        case ChallengeTeamdashboardStatus.ongoing:
          return `${CAROUSEL_CARD_DATES.daysLeft(calculateDaysLeft(complete60Date))}`;
          break;
        case ChallengeTeamdashboardStatus.reward_period:
          return `${CAROUSEL_CARD_DATES.ongoing.rewardPeriod} ${thaiDate(rewardEndDate, dateCompleteFormat)}`
          break;
        case ChallengeTeamdashboardStatus.weight_end:
          return `${CAROUSEL_CARD_DATES.ongoing.weightEnd} ${thaiDate(weightStartDate, dateMonthFormat)} - ${thaiDate(weightEndDate, dateCompleteFormat)}`
          break;
        case ChallengeTeamdashboardStatus.remove_team:
          return `${CAROUSEL_CARD_DATES.ongoing.removeTeam}`
        case ChallengeTeamdashboardStatus.end_challenge:
          return `${CAROUSEL_CARD_DATES.ongoing.endChallenge}`
        default:
          return null;
      }
    }
  }

  const getBeginDetailsContent = (cardObj, profileObj, tagStatus, canRegister, approveDate) => {
    const {
      challengeStatus: challengeType,
      startDate: regStartDate,
      completeDate: rewardEndDate,
      endDate: regEndDate
    } = cardObj || {};
    const {
      approvalTeamdate,
      complete60Date,
      weightoutDate: { startDate: weightStartDate, endDate: weightEndDate } = {},
      completeTeamIn,
    } = profileObj?.teamInfo || {};
    const todayDate = getChallengeTodayDate();
    const daysLeftToReg = calculateDaysLeft(regEndDate);
    const daysTeamDeadLine = calculateDaysLeft(completeTeamIn);
    const regEndOnlyDate = getIsoFormattedDate(regEndDate);
    const dateCompleteFormat = 'dd MMM yy';
    const dateMonthFormat = 'dd MMM';

    if (challengeType === CHALLENGE_LIST.TYPES.upcoming || (challengeType === CHALLENGE_LIST.TYPES.ongoing && canRegister)){
      if(todayDate <= regEndDate){
        return `${CAROUSEL_CARD_DATES.upcoming.beforeReg} ${thaiDate(regStartDate, dateCompleteFormat)} - ${thaiDate(regEndDate, dateCompleteFormat)}`
      }
    }

    if (challengeType === CHALLENGE_LIST.TYPES.ongoing) {
      switch (tagStatus) {
        case ChallengeTeamdashboardStatus.begin_add_member:
          if (todayDate <= regEndDate) {
            return `${CAROUSEL_CARD_DATES.ongoing.notStarted} ${thaiDate(completeTeamIn, dateCompleteFormat)}`;
          }
          break;
        case ChallengeTeamdashboardStatus.begin_ready_to_start:
          if (todayDate < regEndDate) {
            return `${CAROUSEL_CARD_DATES.ongoing.readyToStart}`;
          }
          break;
        case ChallengeTeamdashboardStatus.begin_ongoing:
          return `${CAROUSEL_CARD_DATES.ongoing.started}  ${thaiDate(approveDate, dateCompleteFormat)} - ${thaiDate(complete60Date, dateCompleteFormat)}`;
          break;
        case ChallengeTeamdashboardStatus.begin_weight_end:
          return `${CAROUSEL_CARD_DATES.ongoing.begin_endChallenge} ${thaiDate(weightEndDate, dateCompleteFormat)}`
          break;
        case ChallengeTeamdashboardStatus.end_challenge:
          return `${CAROUSEL_CARD_DATES.ongoing.begin_endChallenge} ${thaiDate(weightEndDate, dateCompleteFormat)}`
        default:
          return null;
      }
    }

  }

  const renderCarouselCard = (cardObj) => {
    const profileStatus = getProfileStatus(cardObj);
    const { eventProfileObj, isRegistered, tagStatus, teamSize, challengeDate, isChallengeStarted } = profileStatus;
    const challengeType = cardObj?.challengeStatus;
    const registrationExpired = isRegDateExpired(cardObj?.completeDate);
    const isUpcomingAndNotExpired = challengeType === CHALLENGE_LIST.TYPES.upcoming && !registrationExpired;
    const isNotRegisteredAndNotExpired = !isRegistered && !registrationExpired;
    const isRegisteredAndCanAddMembers = isRegistered && (teamSize < eventProfileObj?.maxTeamSize) && !registrationExpired;
    const showInviteImg = isUpcomingAndNotExpired || isNotRegisteredAndNotExpired || isRegisteredAndCanAddMembers;
    const inActiveClass = registrationExpired  ? 'card-container-inactive' : '';

    return (
      <div
        key={cardObj?.id}
        className={`card-container-list ${inActiveClass}`}
        onClick={() => handleCardClick(cardObj, isRegistered, inActiveClass, eventProfileObj?.challengeType)}
      >
        <img className={`card-image-list`} src={cardObj?.challengeCardImg} />
        {showInviteImg && (
          <div className='challenge-invite-img' onClick={(e) => handleInviteClick(e, cardObj?.challengeLink)}>
            <img src='/images/challenge/icons/invite-icon.svg' />
          </div>
        )}
        {isProfileLoading && (
          <div className="challenge-profiles">
            <ChallengeUsersLoader count={4} />
          </div>
        )}
        {!isProfileLoading && isRegistered && (
          <div className="challenge-profiles">
            <ChallengeUsers usersList={eventProfileObj.usersInfo} showUserTag={!isChallengeStarted} status={tagStatus?.status}
              teamSize={eventProfileObj?.maxTeamSize ?? eventProfileObj?.maxTeamSize} />
          </div>
        )}
        {!isProfileLoading && showTag && isRegistered && isChallengeStarted && tagStatus?.status && (
          <div className={`challenge-tag-wrapper${eventProfileObj?.usersInfo?.length
            ? ` ${ALIGN_CLASS[eventProfileObj?.usersInfo?.length]}` : ''}`}>
            <ChallengeTag status={tagStatus?.status} challengeDay={challengeDate} />
          </div>
        )}
        <div className="card-container-details">
          <div className="card-container-details-title">{cardObj.name}</div>
          <div className="card-container-details-description">
            {getDetailsContent(cardObj, eventProfileObj, tagStatus?.status, isNotRegisteredAndNotExpired)}
          </div>
        </div>
      </div>
    );
  };

  const renderBeginChallengeCard = (cardObj) => {
    const profileStatus = getBeginProfileStatus(cardObj);
    const { eventProfileObj, eventTeam, isRegistered, tagStatus, teamSize, isChallengeStarted, challengeDate} = profileStatus;
    const challengeType = cardObj?.challengeStatus;
    const registrationExpired = isRegDateExpired(cardObj?.completeDate);
    const isUpcomingAndNotExpired = challengeType === CHALLENGE_LIST.TYPES.upcoming && !registrationExpired;
    const isNotRegisteredAndNotExpired = !isRegistered && !registrationExpired;
    const isRegisteredAndCanAddMembers = isRegistered && (teamSize < eventProfileObj?.maxTeamSize) && !registrationExpired;
    const showInviteImg = isUpcomingAndNotExpired || isNotRegisteredAndNotExpired || isRegisteredAndCanAddMembers;
    const inActiveClass = registrationExpired  ? 'card-container-inactive' : '';
    const teamMissing = eventProfileObj?.maxTeamSize - teamSize
    return (
      <div
        key={cardObj?.id}
        className="card-container-list"
        onClick={() => onBeginChallengeClick(cardObj, isRegistered, inActiveClass, eventProfileObj?.challengeType)}
      >
        <img
          className="card-image-list"
          src={cardObj?.challengeCardImg}
        />

        {tagStatus?.status && (
          <div className="begin-challenge-tag-wrapper">
            <BeginChallengeTag
              status={tagStatus?.status}
              teamMissing={teamMissing}
              challengeDay={challengeDate}
            />
          </div>
        )}

        <div className="card-container-details">
          <div className="card-container-details-title">
            {cardObj?.name}
          </div>
 
          <div className="card-container-details-description">
            {getBeginDetailsContent(cardObj, eventProfileObj, tagStatus?.status, isNotRegisteredAndNotExpired, eventTeam?.approveDate)}
          </div>
        </div>

      </div>
    );
  };

  const carouselRef = useRef(null);

  useEffect(() => {
    if (carouselRef.current) {
      carouselRef.current.slickGoTo(0);
    }
  }, [carouselList])

  return (
    <>
      {isLoading && <ChallengeCarouselLoader />}
      {!isLoading && carouselList?.length > 0 && (
        <div className="challenge-carousel-main">
          {title && <div className="carousel-title">{title}</div>}
          <div className={`carousel-content-list`}>
            <Slider {...settings} ref={carouselRef}>
              {carouselList.map((cardObj) =>
                cardObj.eventId == process.env.REACT_APP_BEGIN_CHALLENGE_EVENT_ID
                  ? renderBeginChallengeCard(cardObj)
                  : renderCarouselCard(cardObj)
              )}
            </Slider>
          </div>
        </div>
      )}
    </>
  );
};

export default ChallengeCarousel;
